import jQuery from 'jquery';

const $ = jQuery;

// Cache our roundup related elements and give them more meaningful variable names.
let $roundupYesRadio = $('#roundup'),
    $roundupFormElementsContainer = $('.roundup-container'),
    $roundupYesNoRadios = $('input[type=radio][name="roundup"]'),
    $roundupAmountInput = $("#roundup_amount"),
    $addGiftAidYesRadio = $('#add_gift_aid_yes'),
    $addGiftAidYesNoRadios = $('#add_gift_aid_yes, #add_gift_aid_no'),
    $donationGiftAidAndEntryTotalBasketElements = $('.donation-container, .giftaid-choice-container, .entry-total-container'),
    $numEntriesInputs = $('input[name="num_entries"]'),
    $perTicketPriceHiddenInput = $('#per_ticket_price'),
    $basketContainerSidebarElement = $('.basket-container'),
    $numberOfEntriesBasketSidebarElement = $('.number-of-tickets'),
    $monthlyCostBasketSidebarElement = $('.monthly-cost'),
    $donationBasketSidebarElement = $('.donation'),
    $giftAidChoiceBasketSidebarElement = $('.giftaid-choice'),
    $entryTotalBasketSidebarElement = $('.entry-total');


function toggleRoundupContainerVisibility() {

    // If the Yes checkbox is checked then show our roundup form elements
    if ($roundupYesRadio.prop('checked')) {
        $roundupFormElementsContainer.slideDown();
    } else {
        // If it is not, then hide it, but also uncheck the gift aid optin
        $roundupFormElementsContainer.slideUp();
        $addGiftAidYesNoRadios.prop('checked', false);
    }

    // "Fake" a click on the selected ticket quantity input in order to recalculate the basket values
    $numEntriesInputs.filter(':checked').click();
}

function keepChange() {

    // If we don't have a "yes keep the change radio" then bail out.
    if (!$roundupYesRadio.length)
        return false;

    // If the "yes keep the change radio" is NOT checked then hide our roundup form elements.
    if ($roundupYesRadio.prop('checked') === false) {
        $roundupFormElementsContainer.hide();
    }

    // When clicking the Yes/No roundup radios toggle hide or show our roundup form elements
    $roundupYesNoRadios.on('change', function () {
        toggleRoundupContainerVisibility();
    });

    // If we click "Yes/No" to gift aid then refresh our basket display in the sidebar
    $addGiftAidYesNoRadios.click(function (e) {
        basketUpdate();
    });

    // When we click outside our roundup amount input refresh the basket display
    $roundupAmountInput.on("blur", function () {
        basketUpdate();
    });

    // Check for roundup element visibility on page load.
    toggleRoundupContainerVisibility();

    // Setup click handler on the num entries inputs — pass $(this) to avoid
    // the race condition where :checked hasn't updated yet when the event fires.
    $numEntriesInputs.on('change', function () {
        console.log('changed:', $(this).val(), $(this).attr('id'));
        suggestRoundUp($(this).val());
        basketUpdate($(this));
    });
}

/**
 * Take our current entry quantity and add our round up price to the ticket total
 * @param {number} $quantity
 * @returns {{final_total: string, ticket_total: string, entered_roundup_amount: string}}
 */
function totalRoundUp($quantity) {

    var per_ticket_price = parseFloat($perTicketPriceHiddenInput.val()).toFixed(2);

    var ticket_total = $quantity * per_ticket_price;
    ticket_total = ticket_total.toFixed(2);

    var entered_roundup_amount = parseFloat($roundupAmountInput.val()).toFixed(2);

    var final_total = (+parseFloat(ticket_total) + +parseFloat(entered_roundup_amount)).toFixed(2);

    return {
        'ticket_total': ticket_total,
        'entered_roundup_amount': entered_roundup_amount,
        'final_total': final_total
    };
}

/**
 * Recalculate our basket values and update the page markup.
 * @param {jQuery} [$clicked] - The element that was just clicked (optional).
 */
function basketUpdate($clicked) {
    updateBasketMarkup(updateBasketData($clicked));
}

/**
 * Find our selected entries radio quantity and recalculate our basket totals
 * taking our roundup amount into account.
 * @param {jQuery} [$clicked] - The element that was just clicked (optional).
 *                              Passed in to avoid the race condition where
 *                              filter(':checked') hasn't updated yet.
 * @returns {{final_total: string, ticket_total: string, entered_roundup_amount: string, qty: number}}
 */
function updateBasketData($clicked) {
    let qty = 0,
        num_entries;

    // Use the clicked element if provided, otherwise fall back to :checked.
    let $checked = ($clicked && $clicked.length) ? $clicked : $numEntriesInputs.filter(':checked');

    if ($checked.length && $checked.val()) {
        num_entries = $checked.attr('id').replace('num_entries', '');
        qty = $checked.val().replace(/\D/g, '');
    }

    let properties = {};
    properties['qty'] = qty;

    // Merge the return values of totalRoundUp with the properties object and return that.
    return Object.assign(properties, totalRoundUp(properties['qty']));
}

/**
 * Find our suggested round up amount based on the number of entries selected.
 * Only apply this value if we are opting in to roundups, otherwise blank the field.
 * @param {string|number} $quantity
 */
function suggestRoundUp($quantity) {
    let suggestedAmount = "";
    if ($roundupYesRadio.prop('checked')) {
        suggestedAmount = parseFloat($('#round_up_amount_' + $quantity).val());
    }
    $roundupAmountInput.val(suggestedAmount);
}

/**
 * Update our sidebar basket markup with our new roundup values.
 * @param {object} properties
 */
function updateBasketMarkup(properties) {
    let qty = parseInt(properties['qty']),
        ticket_total = parseFloat(properties['ticket_total']),
        entered_roundup_amount = parseFloat(properties['entered_roundup_amount']).toFixed(2),
        final_total = parseFloat(properties['final_total']).toFixed(2);

    // If our roundup amount is not an actual number, zero it out.
    if (isNaN(entered_roundup_amount)) {
        entered_roundup_amount = 0;
    }

    // If our final total is not a valid number then use our monthly ticket total —
    // probably means we aren't using the roundup system.
    if (isNaN(final_total)) {
        final_total = ticket_total;
    }

    // If we have checked yes to gift aid when rounding up, display yes in the sidebar basket.
    let giftaid_text_val = 'No';
    if ($addGiftAidYesRadio.prop('checked')) {
        giftaid_text_val = 'Yes';
    }

    if (qty > 0) {

        // Update our main basket elements with our new roundup values.
        $basketContainerSidebarElement.show();
        $numberOfEntriesBasketSidebarElement.html(qty);
        $monthlyCostBasketSidebarElement.html(ticket_total);
        $donationBasketSidebarElement.html(entered_roundup_amount);
        $giftAidChoiceBasketSidebarElement.html(giftaid_text_val);
        $entryTotalBasketSidebarElement.html(final_total);

        // If we have opted in to roundups then show roundup specific fields, otherwise hide them.
        if ($roundupYesRadio.prop('checked')) {
            $donationGiftAidAndEntryTotalBasketElements.show();
        } else {
            $donationGiftAidAndEntryTotalBasketElements.hide();
        }

    } else {
        // If we haven't selected any entries hide our basket sidebar completely.
        $basketContainerSidebarElement.hide();
    }
}

/**
 * When the page has loaded setup our "Keep the change" logic then update the basket markup.
 */
$(document).ready(function (e) {
    keepChange();
    $numEntriesInputs.on('change', function () {
        basketUpdate($(this));
    });
    basketUpdate();
});